module.exports = __webpack_public_path__ + "media/images/get-current-status-4612c242afae3bfb35213b6ac2d15611.svg";